import { Injectable } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';
import { ApiService } from '../base/api.service';
import { ApiEndpointsService } from '../base/api-endpoints.service';
import { ServerResponse } from '../../interfaces/base/server.response';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { Report } from '../../interfaces/report/report';

@Injectable()

export class TrackAndTraceService {

  constructor(private api: ApiService,
              private apiEndpoints: ApiEndpointsService,
  ) {
  }

  get(reportUniqueId: string): Observable<ServerResponse> {
    return this.api.get(this.apiEndpoints.get('reports.track-and-trace', {':report_unique_id': reportUniqueId}));
  }

  save(reportUniqueId: string, formData: any): Observable<boolean | number | Report> {
    return new Observable<boolean | number | Report>((o: Subscriber<boolean | number | Report>): void => {
      this.api.postWithProgress(this.apiEndpoints.get('reports.track-and-trace', {':report_unique_id': reportUniqueId}), formData).subscribe({
        next: (event: HttpEvent<any>): void => {
          if (event.type === HttpEventType.UploadProgress && event.total) {
            o.next(Math.round((event.loaded / event.total) * 100));
          }

          if (event.type === HttpEventType.Response) {
            if (event.ok) {
              o.next(<Report>event.body.data);
            } else {
              o.next(false);
            }
            o.complete();
          }
        },
        error: (res): void => {
          const error: { message: string } = {
            message: null
          };
          if (typeof res.message !== 'undefined') {
            error.message = res.message;
          }

          o.next(false);
        }
      });
    });
  }

  downloadAttachment(reportUniqueId: string, attachment_id: number): void {
    this.api.download(this.apiEndpoints.get('reports.download-attachment', {':report_unique_id': reportUniqueId, ':attachment_id': attachment_id}));
  }

  downloadHandlingAttachment(reportUniqueId: string, attachment_id: number): void {
    this.api.download(this.apiEndpoints.get('reports.download-handling-attachment', {':report_unique_id': reportUniqueId, ':attachment_id': attachment_id}));
  }
}
